import { IInstantWebsiteSettings } from './instant-website-data.data';

export enum ActionsEnum {
  FETCH_INSTANT_WEBSITE_SETTINGS = 'FETCH_INSTANT_WEBSITE_SETTINGS',
  FETCH_INSTANT_WEBSITE_SETTINGS_SUCCESS = 'FETCH_INSTANT_WEBSITE_SETTINGS_SUCCESS',
  FETCH_INSTANT_WEBSITE_SETTINGS_ERROR = 'FETCH_INSTANT_WEBSITE_SETTINGS_ERROR',
  SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK = 'SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK',
  SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_SUCCESS = 'SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_SUCCESS',
  SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_ERROR = 'SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_ERROR',
}

//action payloads
export interface IInstantWebsiteSettingsPayload {
  settings: IInstantWebsiteSettings;
}

export interface IErrorPayload {
  error: Error;
}

// action definitions
export interface FetchInstantWebsiteSettings {
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS;
}

export interface FetchInstantWebsiteSettingsSuccess {
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_SUCCESS;
  payload: IInstantWebsiteSettingsPayload;
}

export interface FetchInstantWebsiteSettingsError {
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_ERROR;
  payload: IErrorPayload;
}

export interface SaveInstantWebsiteSettingsNetwork {
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK;
  payload: IInstantWebsiteSettingsPayload;
}

export interface SaveInstantWebsiteSettingsNetworkSuccess {
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_SUCCESS;
  payload: IInstantWebsiteSettingsPayload;
}

export interface SaveInstantWebsiteSettingsNetworkError {
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_ERROR;
  payload: IErrorPayload;
}

// action creators
export const fetchInstantWebsiteSettings = () => ({
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS,
});

export const fetchInstantWebsiteSettingsSuccess = (
  settings: IInstantWebsiteSettings
): FetchInstantWebsiteSettingsSuccess => ({
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_SUCCESS,
  payload: {
    settings,
  },
});

export const fetchInstantWebsiteSettingsError = (
  error: Error
): FetchInstantWebsiteSettingsError => ({
  type: ActionsEnum.FETCH_INSTANT_WEBSITE_SETTINGS_ERROR,
  payload: {
    error,
  },
});

export const saveInstantWebsiteSettingsNetwork = (
  settings: IInstantWebsiteSettings
): SaveInstantWebsiteSettingsNetwork => ({
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK,
  payload: {
    settings,
  },
});

export const saveInstantWebsiteSettingsNetworkSuccess = (
  settings: IInstantWebsiteSettings
): SaveInstantWebsiteSettingsNetworkSuccess => ({
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_SUCCESS,
  payload: {
    settings,
  },
});

export const saveInstantWebsiteSettingsNetworkError = (
  error: Error
): SaveInstantWebsiteSettingsNetworkError => ({
  type: ActionsEnum.SAVE_INSTANT_WEBSITE_SETTINGS_NETWORK_ERROR,
  payload: {
    error,
  },
});
